export default "<mat-spinner-button [options]=\"matSpinnerOptions\"> </mat-spinner-button>\n"